import { globalConstants, brandProfileConstants } from "../../constants";

const { SUCCESS } = globalConstants;
const {
  FETCH_BRAND,
  FETCH_BRAND_PROFILE,
  GET_BRAND_LOCATIONS,
  FETCH_BRAND_RESTAURANT,
} = brandProfileConstants;

const initialState = {
  stores: [],
  brandData: [],
  brand: {},
  brandProfile: {},
  collectiveData: {},
  brandDataPagination: {
    size: 10,
    number: -1,
    totalElements: 0,
  },
};

export const brandProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BRAND_RESTAURANT + SUCCESS:
      return {
        ...state,
        brandData: action.data.data,
        brandDataPagination: action.data.page,
        collectiveData: action.data.componentData,
      };
    case FETCH_BRAND_PROFILE + SUCCESS:
      return {
        ...state,
        brandProfile: action.data,
      };
    case GET_BRAND_LOCATIONS + SUCCESS:
      return {
        ...state,
        stores: action.data.storeList,
      };
    case FETCH_BRAND + SUCCESS:
      return {
        ...state,
        brand: action.data,
      };
    default:
      return state;
  }
};
